import React from "react";
import { CustomButton } from "../custom/custom-button.jsx";
import { HiOutlineDownload } from "react-icons/hi";
import { BiFilterAlt } from "react-icons/bi";
import { FiEdit } from "react-icons/fi";
import { RiDeleteBinLine } from "react-icons/ri";
import { FetchAllPayouts } from "../../lib/index.jsx";
import helperService from "../../services/helper.service.js";
import moment from "moment";

function Payouts({ handleExport, handleEditPayout, handleDeletePayout }) {
	const { fetchingPayouts, allPayouts } = FetchAllPayouts();

	return (
		<div className="flex flex-col gap-5 w-full md:w-[90%]">
			<div className="flex items-center justify-between">
				<h1 className="text-[16px] font-[600] text-[#1E1E1E] font-jakarta">
					Pending Payouts
				</h1>
				{allPayouts.length > 0 ? (
					<CustomButton
						onClick={() => handleExport(allPayouts)}
						className="!h-[38px] !w-[104px] !text-[#1E1E1E] !text-[14px] !font-[400] !outline-[#C9C9C9] hover:!bg-[#002564] hover:!text-white !rounded-[8px] flex items-center justify-center transition-all duration-300 ease-in-out"
					>
						Export <HiOutlineDownload className="text-[16px] ml-1" />
					</CustomButton>
				) : null}
			</div>

			<div className="overflow-x-auto hidden md:block">
				<table className="w-full border-collapse">
					<thead>
						<tr>
							{[
								"Client Name",
								"Amount",
								"Start Date",
								"Next Due Date",
								"Frequency",
								"Cycles",
								"Status",
								"Actions",
							].map((header) => (
								<th
									key={header}
									className="p-2 text-left text-[14px] text-[#002564] font-[600] font-jakarta"
								>
									{header === "Status" ? (
										<div className="flex items-center">
											Status
											<BiFilterAlt className="ml-1 text-[16px] text-[#002564]" />
										</div>
									) : (
										header
									)}
								</th>
							))}
						</tr>
					</thead>
					<tbody>
						{fetchingPayouts ? (
							<tr>
								<td
									colSpan={7}
									className="text-center py-5 text-[#888] text-[14px] font-jakarta animate-pulse"
								>
									Loading payouts...
								</td>
							</tr>
						) : allPayouts.length === 0 ? (
							<tr>
								<td
									colSpan={7}
									className="text-center py-5 text-[#888] text-[14px] font-jakarta"
								>
									No payouts found.
								</td>
							</tr>
						) : (
							allPayouts.map((payout) => (
								<tr key={payout.id}>
									<td className="p-2 w-[20%] text-[#121212] text-[13px] font-[500] font-jakarta">
										{payout?.clientName}
									</td>
									<td className="p-2 text-[#121212] text-[13px] font-[500] font-jakarta">
										{helperService.handleMoneyFormat(
											payout?.amount,
											2,
											true,
											"NGN"
										)}
									</td>
									<td className="p-2 text-[#121212] text-[13px] font-[500] font-jakarta">
										{moment(payout?.dueDate).format("MMM DD, YYYY")}
									</td>
									<td className="p-2 text-[#121212] text-[13px] font-[500] font-jakarta">
										{moment(payout?.nextDueDate).format("MMM DD, YYYY")}
									</td>
									<td className="p-2 text-[#121212] text-[13px] font-[500] font-jakarta">
										{helperService.capitalize(payout?.frequency)}
									</td>
									<td className="p-2 text-[#121212] text-[13px] font-[500] font-jakarta">
										{payout?.cycle}
									</td>
									<td className="pl-2 py-2">
										<span
											className={`px-3 pt-[5px] pb-[6px] rounded-[5px] !text-[12px] font-[600] font-jakarta ${
												payout?.status === "completed"
													? "bg-[#D9FFCF] text-[#34A864]"
													: payout?.status === "pending"
														? "bg-[#FEF3C7] text-[#A86434]"
														: "bg-gray-200 text-gray-700"
											}`}
										>
											{helperService.capitalize(payout?.status)}
										</span>
									</td>
									<td className="flex p-2 gap-5">
										<FiEdit
											className="text-[#002564] cursor-pointer hover:scale-[1.2] transition-all duration-300 ease-in-out"
											onClick={() => handleEditPayout(payout)}
										/>
										<RiDeleteBinLine
											className="text-[#FF2E31] cursor-pointer hover:scale-[1.2] transition-all duration-300 ease-in-out"
											onClick={() => handleDeletePayout(payout)}
										/>
									</td>
								</tr>
							))
						)}
					</tbody>
				</table>
			</div>

			{/* Mobile View */}
			<div className="md:hidden flex flex-col gap-4">
				{fetchingPayouts ? (
					<p className="text-center text-[#888] text-[14px] font-jakarta animate-pulse">
						Loading payouts...
					</p>
				) : allPayouts.length === 0 ? (
					<p className="text-center text-[#888] text-[14px] font-jakarta">
						No payouts found.
					</p>
				) : (
					allPayouts.map((payout, index) => (
						<div
							key={index}
							className="flex flex-col gap-2 border rounded-lg p-4 shadow-sm bg-white font-jakarta"
						>
							<div className="flex items-center justify-between">
								<p className="text-[14px] font-[600] text-[#002564] mb-2">
									{payout.companyName}
								</p>

								<span
									className={`px-2 py-1 text-sm rounded !text-[11px] font-[600] capitalize ${
										payout.status === "Completed"
											? "bg-[#D9FFCF] text-[#34A864]"
											: payout.status === "Pending"
												? "bg-[#FEF3C7] text-[#A86434]"
												: "bg-gray-200 text-gray-700"
									}`}
								>
									{payout.status}
								</span>
							</div>
							<p className="text-[13px] text-[#121212]">
								Amount:{" "}
								{helperService.handleMoneyFormat(
									payout?.amount,
									2,
									true,
									"NGN"
								)}
							</p>
							<p className="text-[13px] text-[#121212]">
								Start Date: {moment(payout?.dueDate).format("MMM DD, YYYY")}
							</p>
							<p className="text-[13px] text-[#121212]">
								Next Due Date:{" "}
								{moment(payout?.nextDueDate).format("MMM DD, YYYY")}
							</p>
							<p className="text-[13px] text-[#121212]">
								Frequency: {payout.frequency}
							</p>
							<p className="text-[13px] text-[#121212] mb-2">
								Cycles: {payout.cycle}
							</p>
							<div className="">
								<button
									className="px-3 py-1 text-[12px] bg-[#002564] text-white rounded font-jakarta"
									onClick={() => handleEditPayout(payout)}
								>
									Edit
								</button>
								<button
									className="ml-2 px-3 py-1 text-[12px] bg-[#FF2E31] text-white rounded font-jakarta"
									onClick={() => handleDeletePayout(payout)}
								>
									Delete
								</button>
							</div>
						</div>
					))
				)}
			</div>
		</div>
	);
}

export default Payouts;
